import React from 'react'
import moment from 'moment'
import TableValueAction from '../../../MuiTable/components/TableValueAction'
import InfoCpa from '../../../Camiones/containers/busquedaCpa/InfoCpa'

export const COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO = [
  {
    name: 'fechaDeEgresoPlaya',
    label: 'Egreso de playa',
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect',
      customBodyRender: f => {
        moment.locale('ar-AR')
        const fecha = moment(f).format('DD-MM-YY HH:mm')
        return <div>{fecha}</div>
      }
    }
  },
  {
    name: 'numero',
    label: 'Número',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (numero) => {
        return (
          <>
            {numero
              ? <TableValueAction
                value={numero}
                title=' '
                content={<InfoCpa cpa={numero} />} />
              : null
            }
          </>
        )
      }
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      filterType: 'checkbox',
      filterList: []
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: true,
      sort: true,
      customBodyRender: v => {
        return <> { (v.trim() === 'UNDEF') ? ' - ' : v } </>
      }
    }
  },
  {
    name: 'camion',
    label: 'Camión',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 100,
    options: {
      filter: true,
      sort: true,
      filterType: 'multiselect'
    }
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'titular',
    label: 'Titular carta de porte',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'corredorComprador',
    label: 'Corredor Vta. Primaria',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'autodescargable',
    label: 'Autodescargable',
    options: {
      filter: true,
      sort: true,
      display: false,
      filterList: [],
      customBodyRender: autodescargable => {
        return (autodescargable) ? 'Si' : '  '
      }
    }
  },
  {
    name: 'turnoDeSalida',
    label: 'Turno de salida',
    options: {
      filter: false,
      sort: true,
      display: false
    }
  }

]
export const COLUMNS_CAMIONES_ENTRE_PLAYA_CALADO_TO_PRINT = [
  {
    name: 'fechaDeEgresoPlaya',
    label: 'Egreso de playa',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'cartadeporte',
    label: 'CTG',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'camion',
    label: 'Camion',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'titularDeCupo',
    label: 'Titular de cupo',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'titular',
    label: 'Titular de carta porte',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'corredorComprador',
    label: 'Corredor Vta. Primaria',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'vendedor',
    label: 'Entregador',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'turnoDeSalida',
    label: 'Turno de salida',
    width: 50,
    mantenerCase: true
  }
]
